module.exports = __webpack_public_path__ + "img/kab20-gif.9b18f661.gif";